<template>
  <div
    class="cus_status"
    :class="classes"
  >
    <slot></slot>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import {
  STATUS_WON_SELLER,
  STATUS_WON_BIDDER,
  STATUS_BIDDING_SELLER,
  STATUS_FORWARDER_WHEN_SELLER_BAN
} from '@/constants/dbConstant';

const props = defineProps({
  item: {
    required: true,
    type: [Number, String],
  },
});

const classes = computed(() => {
  let className = '';
  if (props.item === STATUS_WON_SELLER[STATUS_BIDDING_SELLER.AWAIT_WON_BIDDER]
    || props.item === STATUS_WON_SELLER[STATUS_BIDDING_SELLER.AWAIT_WON_BIDDER_HAVE_FORWARD]
    || props.item === STATUS_WON_BIDDER[STATUS_BIDDING_SELLER.AWAIT_WON_BIDDER_HAVE_FORWARD]
    || props.item === STATUS_WON_BIDDER[STATUS_BIDDING_SELLER.AWAIT_WON_BIDDER]
    || props.item === STATUS_WON_SELLER[STATUS_BIDDING_SELLER.AWAIT_FORWARDER]
    || props.item === STATUS_WON_SELLER[STATUS_BIDDING_SELLER.AWAIT_FORWARDER_HAVE_FORWARD]
    || props.item === STATUS_WON_BIDDER[STATUS_BIDDING_SELLER.AWAIT_FORWARDER_HAVE_FORWARD]
    || props.item === STATUS_WON_BIDDER[STATUS_BIDDING_SELLER.AWAIT_FORWARDER]
  ) {
    className = '__yellow_f7';
  } else if (props.item === STATUS_WON_BIDDER[STATUS_BIDDING_SELLER.WON_BIDDER_DELETE_SELLER]
    || props.item === STATUS_WON_BIDDER[STATUS_BIDDING_SELLER.FORWARDER_DELETE_SELLER]
    || props.item === STATUS_FORWARDER_WHEN_SELLER_BAN
  ) {
    className = '__red_fd';
  } else if (props.item === STATUS_WON_SELLER[STATUS_BIDDING_SELLER.WON_BIDDER_ACCEPT]
    || props.item === STATUS_WON_BIDDER[STATUS_BIDDING_SELLER.WON_BIDDER_ACCEPT]
    || props.item === STATUS_WON_SELLER[STATUS_BIDDING_SELLER.AWAIT_FORWARDER_ACCEPT]
    || props.item === STATUS_WON_BIDDER[STATUS_BIDDING_SELLER.AWAIT_FORWARDER_ACCEPT]
    || props.item === STATUS_WON_BIDDER[STATUS_BIDDING_SELLER.FORWARDER_REJECT]
  ) {
    className = '__blue_c6';
  } else {
    className = '__gray_4a';
  }

  return className;
});
</script>
